import type { InteractiveButton } from '@/types/interactiveVideo'

/**
 * 答え終えたアンケートの箱（SURVEYノード）へ進む選択肢ボタンを除く。
 *
 * アンケートの箱を答え終えると元の動画へ戻って続きを再生するが（#430）、戻った動画に
 * 「アンケートへ」のボタンが残ると、答え終えたのにまだ答えてと言われているように見え、
 * 押し間違い・二重回答のもとになる。回答済みの記録は視聴セッション中だけ（ページを開き直すと戻る）。
 */
export function withoutCompletedSurveyButtons(
  buttons: InteractiveButton[],
  completedSurveyNodeKeys: ReadonlySet<string>,
): InteractiveButton[] {
  if (completedSurveyNodeKeys.size === 0) return buttons
  return buttons.filter((button) => {
    const action = button.action as { type?: string; targetNodeId?: string }
    return !(
      action.type === 'video_transition' &&
      action.targetNodeId &&
      completedSurveyNodeKeys.has(action.targetNodeId)
    )
  })
}

/** 管理データ形式のボタン（actionType / actionConfig.targetNodeKey）版。BOX の右パネルの選択肢に使う */
export function withoutCompletedSurveyScenarioButtons<T extends { actionType: string; actionConfig: unknown }>(
  buttons: T[],
  completedSurveyNodeKeys: ReadonlySet<string>,
): T[] {
  if (completedSurveyNodeKeys.size === 0) return buttons
  return buttons.filter((button) => {
    const target = (button.actionConfig as { targetNodeKey?: unknown } | null)?.targetNodeKey
    return !(
      button.actionType === 'VIDEO_TRANSITION' &&
      typeof target === 'string' &&
      completedSurveyNodeKeys.has(target)
    )
  })
}
